import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledButton, StyledButtonText, StyledIcon } from './OverlayButton.styles';

class OverlayButton extends Component {
  static propTypes = {
    /** Copy to display inside the button */
    children: PropTypes.node,
    /** Function that runs onClick of button */
    onClick: PropTypes.func,
    /** Icon id for SVGIcon that shows to the right of the text */
    icon: PropTypes.string
  };

  static defaultProps = {
    children: 'Test',
    onClick: () => {},
    icon: null
  };

  render() {
    const { children, onClick, icon } = this.props;
    return (
      <StyledButton className="directions" onClick={onClick}>
        <StyledButtonText tagName="span" noMargins>
          {children}
        </StyledButtonText>
        {icon && <StyledIcon selectedIcon="directions" />}
      </StyledButton>
    );
  }
}

export default OverlayButton;
